<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="cancel">{{ $t("cancel") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("addressbook") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right">
            <v-btn text v-show="valid" @click="save">{{ $t("save") }}</v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-list-item v-show="addressLookupVisible">
        <vuetify-google-autocomplete
          ref="address"
          id="map"
          v-model="address"
          :country="addressCountry"
          :placeholder="$t('address_lookup_placeholder')"
          @placechanged="getAddressData"
        ></vuetify-google-autocomplete>
      </v-list-item>

      <v-form v-show="!addressLookupVisible" v-model="valid" ref="form">
        <v-container>
          <v-list-item>
            <v-text-field
              ref="name"
              v-model="name"
              :rules="[inputRules.required]"
              :label="$t('name')"
              required
            ></v-text-field>
          </v-list-item>

          <v-list-item>
            <v-text-field v-model="unit" :label="$t('unit')"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field v-model="street" :rules="[inputRules.required]" :label="$t('street')" required></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field v-model="city" :rules="[inputRules.required]" :label="$t('city')" required></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field
              v-model="province"
              :rules="[inputRules.required]"
              :label="$t('province')"
              required
            ></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field v-model="postal" :rules="[inputRules.postal]" :label="$t('postal')"></v-text-field>
          </v-list-item>

          <v-list-item>
            <v-text-field v-model="phone" :rules="[inputRules.phoneOpt]" :label="$t('phone')"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field v-model="remark" :label="$t('delivery_instruction')"></v-text-field>
          </v-list-item>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    valid: false,
    name: "",

    unit: "",
    street: "",
    city: "",
    province: "",
    postal: "",
    phone: "",
    remark: "",

    addressLookupVisible: false,
    address: "",
    addressCountry: ["ca", "us"],
  }),

  created() {},

  mounted() {},

  computed: {},

  methods: {
    open(addr) {
      this.dialog = true;
      this.address = "";

      //console.log(addr);

      if (addr !== undefined && typeof addr == "object") {
        this.name = addr.name;
        this.unit = addr.unit;
        this.street = addr.street;
        this.city = addr.city;
        this.province = addr.province;
        this.postal = addr.postal;
        this.phone = addr.phone1;
        this.remark = addr.remark;
      } else {
        this.name = undefined;
        this.street = undefined;
        this.city = undefined;
        this.province = undefined;
      }
      this.addressLookupVisible = addr === undefined;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    save() {
      let address = {
        name: this.name,
        unit: this.unit,
        street: this.street,
        city: this.city,
        postal: this.postal,
        province: this.province,
        phone1: this.phone,
        remark: this.remark,
      };

      this.close(address);
    },

    close(result) {
      this.resetForm();
      this.dialog = false;
      this.resolve(result);
    },

    cancel() {
      this.close(null);
    },

    resetForm() {
      this.$refs.form.reset();
    },

    getAddressData(addressData, placeResultData /*, id*/) {
      console.log(addressData);
      console.log(placeResultData);

      let unit = "";
      let street = "";
      let city = "";
      let province = "";
      let postal = "";

      placeResultData.address_components.forEach(element => {
        if (element.types.includes("subpremise")) unit += (unit == "" ? "" : " ") + element.long_name;
        if (element.types.includes("street_number")) street += (street == "" ? "" : "-") + element.long_name;
        if (element.types.includes("route")) street += (street == "" ? "" : " ") + element.long_name;
        if (element.types.includes("locality")) city = element.long_name;
        if (element.types.includes("political") && element.types.includes("administrative_area_level_1"))
          province = element.short_name;
        if (element.types.includes("postal_code")) postal = element.short_name;
      });
      this.name = "";
      this.unit = unit;
      this.street = street;
      this.city = city;
      this.province = province;
      this.postal = postal;

      this.addressLookupVisible = false;
      this.$refs.name.focus();
    },
  },
};
</script>

<style lang="scss" scoped></style>
